import { Form } from 'react-final-form';
import _ from 'lodash';
import { useEntityFullBySlug } from '../modules/entity/Entity';
import { 
  MenuStyleCompact,
  MenuStyleCollapsible
} from "../components/Filters";

const FormContent = (props) => {
  let {
    // filterMenuTaxonomyTypes, // [ FilterPopulated { id, filter, taxonomyType }]
    // form,
    // values,
    // handleSubmit,
    // onFormClear,
    // classes,
    // Components
    style = 'search-collapsible'
  } = props;

  if (style === 'search-collapsible') {
    return <MenuStyleCollapsible {...props} />;
  }
  else if (style === 'search-expanded') {
    return <MenuStyleCollapsible {...props} isAlwaysExpanded={true} />;
  }
  else if (style === 'search-compact') {
    return <MenuStyleCompact {...props} />;
  }
  // style 'selector-compact', 'selector-collapsible' selector no redirige
}

const EntityFilterMenuDisplay = (props) => {
  let {
    entitySlug, 
    filterMenuSlug,
    filterData={},
    onFormChange,
    // Components, onFormClear, style, classes, defaultPath <= for FormContent
  } = props;
  
  let { 
    filterMenuTaxonomyTypes // [ FilterPopulated { id, filter, taxonomyType }]
  } = useEntityFullBySlug({ entitySlug, filterMenuSlug });

  const sanitizeValues = (values) => {
    const sanitizedValues = { ...values };
    for (const prop in sanitizedValues) {
      const value = sanitizedValues[prop];
      if (value === undefined || value === null || value === false) {
        delete sanitizedValues[prop];
      }
      if (Array.isArray(value) && value.length === 0) {
        delete sanitizedValues[prop];
      }
    }
    return sanitizedValues;
  };

  const handleSubmit = (values) => {
    onFormChange && onFormChange(sanitizeValues(values));
  };

  return (
    filterMenuTaxonomyTypes ? (
      <Form
      initialValues={filterData} // prefijo para campos del form
      onSubmit={handleSubmit}>
        {(formProps) => (<>
          <FormContent {...formProps} {...{
            filterMenuTaxonomyTypes,
            ...props
          }}  />
        </>)}
      </Form>
    ) : null
  );
};

export default EntityFilterMenuDisplay;
